export const positions = {
  top: window.theme.localeStrings.monogram.placement_top,
  side: window.theme.localeStrings.monogram.placement_side,
};

export const sizes = {
  small: window.theme.localeStrings.monogram.size_small,
  medium: window.theme.localeStrings.monogram.size_medium,
  large: window.theme.localeStrings.monogram.size_large,
};
